import { selectSlotRecipe } from './selectSlotRecipe';
import { fieldSlotRecipe } from './fieldSlotRecipe';
import { inputRecipe } from './inputRecipe';
import { tableSlotRecipe } from './tableSlotRecipe';
import { basicButtonSlotRecipe } from './basicButtonSlotRecipe';
import { textareaRecipe } from './textareaRecipe';
import { comboBoxSlotRecipe } from './comboBoxSlotRecipe';

// Aquí modificamos las recetas de Chakra para que en nuestro tema tengan el aspecto que queremos
// Se puede ver aquí la estructura que tienen: https://github.com/chakra-ui/chakra-ui/blob/main/packages/react/src/theme/index.ts
// En teoría con modificar los campos que nos hacen falta, chakra ya es listo y hace un merge con lo nuestro y lo suyo como base.

export const slotRecipes = {
	select: selectSlotRecipe,
	field: fieldSlotRecipe,
	table: tableSlotRecipe,
	basicButton: basicButtonSlotRecipe,
	combobox: comboBoxSlotRecipe
};

export const recipes = {
	input: inputRecipe,
	textarea: textareaRecipe
};